import * as React from 'react';
import { HatApplicationContent } from './interfaces/hat-application.interface';
import HmiProvider from './context/HmiProvider';
import './components/Hmi/Hmi.scss';
import './components/CertificateStatus/CertificateStatus.scss';

import MessagesProvider from './context/MessagesProvider';
import HmiAdapter from './components/Hmi/HmiAdapter';

type Props = {
  path?: string;
  applicationId?: string;
  hatName?: string;
  hmiType: string;
  language?: string;
  parentApp: HatApplicationContent;
  dependencyApps?: HatApplicationContent[];
  dependencyTools?: string[] | null;
  onApproved: () => void;
  onRejected: () => void;
};

const Hmi: React.FC<Props> = props => {
  return (
    <HmiProvider
      parentApp={props.parentApp}
      dependencyApps={props.dependencyApps || []}
      hatName={props.hatName}
      hmiType={props.hmiType}
      language={props.language || 'en'}
      dependencyTools={props.dependencyTools}
      onApproved={props.onApproved}
      onRejected={props.onRejected}
    >
      <MessagesProvider language={props.language}>
        <div className={'hmi-page'}>
          <div className={'hmi-page-wrapper'}>
            <HmiAdapter />
          </div>
        </div>
      </MessagesProvider>
    </HmiProvider>
  );
};

export default Hmi;

export { HmiType } from './interfaces/hmi.type';
export { CertificateStatus } from './components/CertificateStatus/CertificateStatus';
export { HmiV2 } from './components/HmiV2/HmiV2';
export { Input } from './components/Input/Input';
export { AgreementsModal } from './components/AgreementsModal/AgreementsModal';
export { IssuedBy } from './components/Footer/IssuedByFooter';
export { AuthApplicationLogo } from './components/AuthApplicationLogo/AuthApplicationLogo';
export { AnalyticsEvent } from './interfaces/analytics-event.interface';
export { default as AnalyticsProvider } from './context/AnalyticsProvider';
export { default as AnalyticsContext } from './context/AnalyticsContext';
export { default as Footer } from './components/Footer/Footer';
